module.exports = __webpack_public_path__ + "img/eufinance.9aab7b34.jpg";